<template>
  <div class="project">
    <div class="list-project columns flex-direction-column" :class="{'full-height': !doneLoading}">
      <div v-if="doneLoading" class="column targets-list flex-align-items">
        <!-- SKAL FIXES -->
        <!-- <input type="text" class="input search-input" :placeholder="$t('global.search')" v-model="searchProject"> -->
        <!-- Sort list -->
        <div class="list-sort columns">
          <div style="display: flex; width: 100%;">
            <div class="column is-1 item sortable no-underline">
              <span>{{$t('profile.profile')}}</span>
              <!-- <select v-model="selectedProfile" @change="sortByProfile($event)" style="margin-left: -22px;">
                <option v-if="profiles.length === 0" value="0" disabled="disabled">{{$t('profile.noProfileTypes')}}</option>
                <option v-if="profiles.length > 0" value="-1" disabled="disabled">{{$t('profile.chooseProfile')}}</option>
                <option v-if="profiles.length > 0" value="0">{{$t('global.all')}}</option>
                <option v-for="profile in profiles" :key="profile.profileId" :selected="profile.profileId" :value="profile.profileId">
                  {{profile.name}}
                </option>
              </select> -->
            </div>
            <!-- project name -->
            <div class="column item" @click="sort('name')" :class="{selected: currentSort === 'name' && !customSearchActive, 'sortable': !customSearchActive}">
              <span>{{$t('modal-project.modalLoadedProjectName')}}</span>
              <div>
                <icon v-if="currentSort === 'name' && !customSearchActive" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'asc' && currentSort === 'name'}" name="keyboard_arrow_sort"></icon>
              </div>
            </div>
            <!-- customer -->
            <div class="column item" @click="sort('customer')" :class="{selected: currentSort === 'customer' && !customSearchActive, 'sortable': !customSearchActive}">
              <span>{{$t('modal-project.modalLoadedProjectCustomer')}}</span>
              <div>
                <icon v-if="currentSort === 'customer' && !customSearchActive" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'asc' && currentSort === 'customer'}" name="keyboard_arrow_sort"></icon>
              </div>
            </div>
            <!-- responsible -->
            <div class="column item" @click="sort('responsible')" :class="{selected: currentSort === 'responsible' && !customSearchActive, 'sortable': !customSearchActive}">
              <span>{{$t('modal-project.modalLoadedProjectResponsible')}}</span>
              <div>
                <icon v-if="currentSort === 'responsible' && !customSearchActive" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'asc' && currentSort === 'responsible'}" name="keyboard_arrow_sort"></icon>
              </div>
            </div>
            <!-- last saved -->
            <div class="column item" @click="sort('saved')" :class="{selected: currentSort === 'saved' && !customSearchActive, 'sortable': !customSearchActive}">
              <span>{{$t('modal-project.modalLoadedProjectLastSaved')}}</span>
              <div>
                <icon v-if="currentSort === 'saved' && !customSearchActive" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'asc' && currentSort === 'saved'}" name="keyboard_arrow_sort"></icon>
              </div>
            </div>
            <!-- description -->
            <div class="column is-4 item">
              <span>{{$t('modal-project.modalLoadedProjectDescription')}}</span>
            </div>
          </div>
        </div>
        <!-- List of projects -->
        <div v-for="project in sortedProjects" :key="project.projectId" class="columns">
          <div @click="setHighlightedProject(project)" :class="{'selected-project': selectedProject && selectedProject.projectId === project.projectId}" class="list-item flex-align-row">
            <div class="column is-1 flex-align-items flex-center">
              <icon class="small-svg" name="byggeri"></icon>
            </div>
            <div class="column flex-align-items">
              <span>{{project.name}}</span>
            </div>
            <div class="column flex-align-items">
              <span>{{project.customer}}</span>
            </div>
            <div class="column flex-align-items">
              <span>{{project.responsible}}</span>
            </div>
            <div class="column flex-align-items">
              <span>{{project.date | formatDate}}</span>
            </div>
            <div class="column is-4" style="overflow: hidden">
              <span>{{project.description}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- loading projects -->
      <div v-else :class="{'full-height': !doneLoading}">
        <div class="flex-center" :class="{'full-height': !doneLoading}">
          <icon class="save-spinner-svg flex sdg-spinner" name="sdg-wheel"></icon>
        </div>
      </div>
      <!-- slider -->
      <transition name="slider">
        <div v-if="selectedProject" class="columns slider-information">
          <div class="close-button" @click="setHighlightedProject()">
            <span aria-hidden="true">×</span>
          </div>
          <icon class="logo-svg" name="sdg-wheel-black"></icon>
          <div v-if="!showRemoveProject" class="column is-12 slider-inner">
            <div class="slider-header">
              <icon class="medium-svg" name="byggeri"></icon>
              <h2 class="bold">{{selectedProject.name}}</h2>
            </div>
            <div class="slider-content">
              <!-- description -->
              <div class="slider-content-item">
                <p class="bold">{{$t('modal-project.modalLoadedProjectDescription')}}</p>
                <p>{{selectedProject.description ? selectedProject.description : $t('modal-project.modalLoadedProjectNoDescription')}}</p>
              </div>
              <!-- customer -->
              <div class="slider-content-item">
                <p class="bold">{{$t('modal-project.modalLoadedProjectCustomer')}}</p>
                <p>{{selectedProject.customer ? selectedProject.customer : $t('modal-project.modalLoadedProjectNoCustomer')}}</p>
              </div>
              <!-- responsible -->
              <div class="slider-content-item">
                <p class="bold">{{$t('modal-project.modalLoadedProjectResponsible')}}</p>
                <p>{{selectedProject.responsible ? selectedProject.responsible : $t('modal-project.modalLoadedProjectNoResponsible')}}</p>
              </div>
              <!-- createdDate -->
              <div class="slider-content-item">
                <p class="bold">{{$t('modal-project.modalLoadedProjectCreated')}}</p>
                <p>{{selectedProject.createdDate | formatDate}}</p>
              </div>
              <!-- date -->
              <div class="slider-content-item">
                <p class="bold">{{$t('modal-project.modalLoadedProjectLastSaved')}}</p>
                <p>{{selectedProject.date | formatDate}}</p>
              </div>
              <!-- versionCount -->
              <div class="slider-content-item">
                <p class="bold">{{$t('modal-project.modalSliderVersionCount')}}</p>
                <p>{{selectedProject.versionCount ? selectedProject.versionCount : '0'}} {{$t('modal-project.modalSliderVersionText')}}<span v-if="selectedProject.versionCount !== 1">{{$t('global.er')}}</span></p>
              </div>
              <!-- versionComment -->
              <div class="slider-content-item">
                <p class="bold">{{$t('modal-project.modalSliderVersionComment')}}</p>
                <p>{{selectedProject.versionComment ? selectedProject.versionComment : $t('modal-project.modalSliderNoVersionComment')}}</p>
              </div>
              <!-- goalCount -->
              <div class="slider-content-item">
                <p class="bold">{{$t('modal-project.modalSliderGoalCount')}}</p>
                <p>{{selectedProject.goalCount ? selectedProject.goalCount : $t('modal-project.modalSliderNoGoalCount')}}</p>
              </div>
            </div>
            <div class="slider-bottom">
              <div class="columns is-multiline">
                <div class="column is-6">
                  <button @click="setSelectedProject('goals')" class="flex-align-center button primary full-width">
                    <icon class="tiny-svg flex fill-white" name="arrow-right"></icon>
                    <span>{{$t('modal-project.modalSliderOpenProject')}}</span>
                  </button>
                </div>
                <div @click="setSelectedProject('results')" class="column is-6">
                  <button class="flex-align-center button primary full-width">
                    <icon class="tiny-svg flex fill-white" name="arrow-right"></icon>
                    <span>{{$t('modal-project.modalSliderGoToResult')}}</span>
                  </button>
                </div>
                <div class="column is-6">
                  <button @click="setRemoveProject(true)" class="flex-align-center button alert full-width">
                    <icon class="tiny-svg flex fill-white" name="bin"></icon>
                    <span>{{$t('modal-project.modalSliderRemoveProject')}}</span>
                  </button>
                </div>
                <!-- <div @click="setSelectedProject('history')" class="column is-6">
                  <button class="flex-align-center button primary full-width">
                    <icon class="tiny-svg flex fill-white" name="arrow-right"></icon>
                    <span>{{$t('modal-project.modalSliderGoToHistory')}}</span>
                  </button>
                </div> -->
                <!-- <div class="column is-6">
                  <button @click="makePDF()" class="flex-align-center button full-width">
                    <icon class="tiny-svg flex" name="pdf-file"></icon>
                    <span>{{$t('top-bar.export')}}</span>
                  </button>
                </div> -->
              </div>
            </div>
          </div>
          <!-- remove project -->
          <div v-else class="column is-12 slider-inner justify-center">
            <div class="slider-header">
              <icon class="medium-svg" name="byggeri"></icon>
              <h2 class="bold">{{selectedProject.name}}</h2>
            </div>
            <h2 class="text-center">{{$t('modal-project.modalCustomDeleteTitle')}}</h2>
            <div class="columns">
              <div class="column is-12">
                <p class="text-center">{{$t('modal-project.modalCustomDeleteText')}}</p>
                <p v-if="errorMessage" class="required text-center">{{errorMessage}}</p>
              </div>
            </div>
            <div class="text-center buttons-group">
              <a @click="handleRemoveProject()" class="button alert">{{$t('tasks.customDeleteOK')}}</a>
              <a @click="setRemoveProject(false)" class="button">{{$t('global.cancel')}}</a>
            </div>
          </div>
        </div>
      </transition>
      <!-- overlay -->
      <div @click="setHighlightedProject()" v-if="selectedProject" class="overlay"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'project',
  data () {
    return {
      // selectedProfile: 0,
      doneLoading: false,
      selectedProject: null,
      showRemoveProject: false,
      errorMessage: null,
      customSearchActive: false,
      searchProject: '',
      // sort
      currentSort: 'saved',
      currentSortDir: 'desc'
    }
  },
  computed: {
    ...mapGetters({
      project: 'getProject',
      projects: 'getProjects',
      profiles: 'getProfiles'
    }),
    sortedProjects () {
      this.setCustomSearchActive(false)
      if (this.searchProject.trim() === '') {
        let sortedArray = this.projects.slice(0).sort((a, b) => {
          let modifier = 1
          if (this.currentSortDir === 'desc') {
            modifier = -1
          }

          if (this.currentSort === 'profile') {
            if (a.profileName < b.profileName) {
              return -1 * modifier
            }
            if (a.profileName > b.profileName) {
              return 1 * modifier
            }
          }

          if (this.currentSort === 'name') {
            if (a.name < b.name) {
              return -1 * modifier
            }
            if (a.name > b.name) {
              return 1 * modifier
            }
          }

          if (this.currentSort === 'customer') {
            if (a.customer < b.customer) {
              return -1 * modifier
            }
            if (a.customer > b.customer) {
              return 1 * modifier
            }
          }

          if (this.currentSort === 'responsible') {
            if (a.responsible < b.responsible) {
              return -1 * modifier
            }
            if (a.responsible > b.responsible) {
              return 1 * modifier
            }
          }

          if (this.currentSort === 'saved') {
            if (a.date < b.date) {
              return -1 * modifier
            }
            if (a.date > b.date) {
              return 1 * modifier
            }
          }

          return 0
        })

        return sortedArray
      }

      if (this.searchProject.trim() !== '') {
        this.setCustomSearchActive(true)
        let splitted = this.searchProject.split(' ')
        let keywords = []
        splitted.forEach(word => {
          if (word.trim() !== '') {
            keywords.push(word.toLowerCase())
          }
        })

        let projects = this.projects.filter(project => project.name.toLowerCase().includes(keywords))

        const existsInArray = (item, array) => {
          let foundAll = true
          for (let i = 0; i < array.length; i++) {
            if (!item.includes(array[i])) {
              foundAll = false
              break
            }
          }
          return foundAll
        }

        const setNewProjects = (item) => {
          let newProjects = this.projects.filter(project => existsInArray(project[item].toLowerCase(), keywords) && !projects.some(foundProject => foundProject.projectId === project.projectId))
          newProjects.forEach(project => {
            projects.push(project)
          })
        }

        setNewProjects('customer')
        setNewProjects('responsible')
        setNewProjects('description')

        projects = projects.sort((a, b) => {
          if (a.name < b.name) {
            return -1 * 1
          }
          if (a.name > b.name) {
            return 1 * 1
          }
        })

        return projects
      }

      // if (this.selectedProfile && this.selectedProfile !== 0) {
      //   let foundProfile = this.profiles.filter(profile => profile.profileId === this.selectedProfile)[0]
      //   if (foundProfile) {
      //     let filteredArray = sortedArray.filter(arr => arr.profileName.toLowerCase() === foundProfile.name.toLowerCase())
      //     if (filteredArray) {
      //       return filteredArray
      //     }
      //   }
      // }
      return []
    }
  },
  methods: {
    ...mapActions({
      setPDF: 'setPDF',
      setProjects: 'setProjects',
      setProfiles: 'setProfiles',
      setProject: 'setProject',
      setProfile: 'setProfile',
      setShowModal: 'setShowModal',
      setModalType: 'setModalType',
      removeProject: 'removeProject',
      setActivePageCode: 'setActivePageCode'
    }),
    setCustomSearchActive (boolean) {
      this.customSearchActive = boolean
    },
    sort (s) {
      if (!this.customSearchActive) {
        if (s === this.currentSort) {
          this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
        }
        this.currentSort = s
        window.localStorage.setItem('sortProject', JSON.stringify({ sort: this.currentSort, sortDir: this.currentSortDir }))
      }
    },
    setHighlightedProject (project) {
      this.showRemoveProject = false
      if (project) {
        if (this.selectedProject) {
          if (this.selectedProject.projectId === project.projectId) {
            this.selectedProject = null
          } else {
            this.selectedProject = project
          }
        } else {
          this.selectedProject = project
        }
      } else {
        this.selectedProject = null
      }
    },
    async setSelectedProject (page) {
      if (this.selectedProject) {
        try {
          let foundProfile = this.profiles.filter(profile => profile.name === this.selectedProject.profileName)[0]
          if (foundProfile) {
            await this.setProfile(foundProfile.profileId)
            try {
              await this.setProject(this.selectedProject.projectId)

              if (page) {
                this.setActivePageCode(page)
              }
            } catch (err) {
              console.log('error getting project from server', err)
            }
          }
        } catch (err) {
          console.log('error getting profile data from server', err)
        }
      }
    },
    async makePDF () {
      try {
        await this.setSelectedProject()

        this.setHighlightedProject()
        this.setShowModal(true)
        this.setModalType('create-pdf-modal')

        try {
          let pdfObject = {
            profileId: this.project.profileId,
            projectJson: '',
            baseUrl: window.location.href,
            resultWheels: []
          }

          // JPED: SKAL FIXES
          // this.$refs.resultWheel.forEach(wheel => {
          //   pdfObject.resultWheels.push(wheel.jsWheel.getSvgText())
          // })

          await this.setPDF(pdfObject)
          this.setShowModal(false)
          this.setModalType(null)
        } catch (err) {
          console.log('error creating PDF', err)
          this.setShowModal(false)
          this.setModalType(null)
        }
      } catch (err) {
        console.log('err set selected project', err)
      }
    },
    // sortByProfile ($event) {
    //   this.selectedProfile = $event.target.value
    // },
    setRemoveProject (boolean) {
      this.showRemoveProject = boolean
    },
    async handleRemoveProject () {
      this.errorMessage = null
      try {
        await this.removeProject(this.selectedProject.projectId)
        this.setHighlightedProject()
      } catch (err) {
        console.log('error removing project', err)
        this.errorMessage = this.$t('modal-project.modalRemoveError')
      }
    }
  },
  filters: {
    truncateRemark (text) {
      return text.substring(0, 80) + '...'
    }
  },
  async created () {
    try {
      await this.setProjects()
      try {
        await this.setProfiles()
        if (window.localStorage.getItem('sortProject')) {
          let retrievedLocalStorage = window.localStorage.getItem('sortProject')
          let parsed = JSON.parse(retrievedLocalStorage)
          this.currentSort = parsed.sort
          this.currentSortDir = parsed.sortDir
        }
        this.doneLoading = true
      } catch (err) {
        console.log('error getting profiles from server', err)
      }
    } catch (err) {
      console.log('error getting projects from server', err)
    }
  }
}
</script>
